(function($) {
  simple.uploader.class.prototype.opts.customXhr = function(
    file,
    ajaxSettings
  ) {
    $.post(
      file.url,
      // % in filename causes rack raising “invalid %-encoding” error
      //   on /oss/xxx/callback
      // @see https://sentry.io/ccw/tower/issues/235516533/events/5538337796/
      // @see https://github.com/rack/rack/issues/337
      // $ to \$
      // @see https://tower.im/projects/a180e8ffe64f4652a2e2039dccd78f33/todos/826b16e39381410aaf679ae4a3f9c671/
      $.extend(
        {
          name: file.name.replace(/%/g, "_").replace(/\$/g, "$"),
          js_id: file.id,
          tree_path: file.obj.webkitRelativePath
        },
        file.params
      )
    )
      .done(function(result) {
        var formData = new FormData();
        formData.append("key", result.key);
        formData.append("OSSAccessKeyId", result.OSSAccessKeyId);
        formData.append("policy", result.policy);
        formData.append("Signature", result.Signature);
        formData.append("callback", result.callback);
        formData.append("file", file.obj);

        var originalOnError = ajaxSettings.error;
        $.extend(ajaxSettings, {
          url: result.url,
          data: formData,
          error: function(xhr, status, err) {
            // when OSS callback fails, OSS responds in XML
            // default error message mechanism expects json
            // and will fail to work
            // maybe parse XML?
            // `$.parseXML(xhr.responseText)`
            if ("application/xml" == xhr.getResponseHeader("content-type")) {
              simple.dialog.message({
                content:
                  "抱歉，上传失败了。我们已经记录了错误，并会尽快修复，不妨稍后再试一下。"
              });
            }

            if ("function" === typeof originalOnError) {
              originalOnError(xhr, status, err);
            }
          }
        });
        file.xhr = $.ajax(ajaxSettings);
      })
      .fail(function(xhr, status, err) {
        ajaxSettings.error(xhr, status, err);
      });
  };
})(jQuery);
